/** Hide declined/superseded write tool rows (Reject or conversational revision). */
export function isUserRejectedWriteToolOutput(output: unknown): boolean {
  if (!output || typeof output !== "object") return false;
  const record = output as Record<string, unknown>;
  return record.success === false;
}
